/* eslint-disable react/jsx-props-no-spreading */
import { getComponentFromName } from '@folklore/utils';
import PropTypes from 'prop-types';
import React from 'react';

import * as Components from '../../interactives/index';

const propTypes = {
    name: PropTypes.string,
};

const defaultProps = {
    name: null,
};

function InteractiveBlock({ name, ...otherProps }) {
    const Component = getComponentFromName(Components, name, null);
    return Component !== null ? <Component {...(otherProps || {})} /> : null;
}

InteractiveBlock.propTypes = propTypes;
InteractiveBlock.defaultProps = defaultProps;

export default InteractiveBlock;
